import { useEffect } from "react";
import Header from "components/Common/Header/Header";
import AppUserSettingsBody from "components/AppUserComponents/AppUserDetails/AppUserSettings/AppUserSettingsBody";

const AppUserSettings = () => {
  useEffect(() => {
    document.title = "App user";
  }, []);

  return (
    <main id="app">
      {/* ---- common header ---- */}
      <Header moduleName="appuser" />
      <AppUserSettingsBody />
    </main>
  );
};

export default AppUserSettings;
